import isEqual from "lodash.isequal"
import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

import { preferencesSuccess } from "../../User/redux/user.actions"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getRequestsWithdrawalRequest: ["payload"], // payload: { params }
  getRequestsWithdrawalSuccess: ["payload"], // payload: { data }
  deleteWithdrawalRequest: ["payload"], // payload: { id }
  deleteWithdrawalSuccess: ["payload"], // payload: { data }

  requestsWithdrawalFailure: ["payload"], // payload: { errors }

  clearRequestsWithdrawalFilters: null,
  requestsWithdrawalSetProp: ["key", "value"],

  getPayoutMethodRequest: ["payload"],
  getPayoutMethodSuccess: ["payload"],
  getPayoutMethodFailure: null,

  setStatusRequest: ["payload"],
  setStatusSuccess: ["payload"],
  setStatusFailure: null,

  logout: null
})

export const RequestsWithdrawalTypes = Types
export default Creators

/* ------------- Initial State ------------- */

const columnsAdmin = [
  // {field_id: 'type', label: 'Type', active: true},
  { field_id: "created_timestamp", label: "Created date", active: true },
  { field_id: "user_full_name", label: "User full name", active: true },
  { field_id: "user_email", label: "User email", active: true },
  { field_id: "amount", label: "Sum", active: true },
  { field_id: "admin_name", label: "Admin name", active: true },
  { field_id: "attachments", label: "Attachments", active: true }
]

export const INITIAL_STATE = Immutable({
  fetching: false,
  result: {
    count: 0,
    next: null,
    previous: null,
    results: []
  },

  defaultColumnsAdmin: [...columnsAdmin],
  columnsAdmin: [...columnsAdmin],

  filtersLastUpd: null,
  filters: {
    created_timestamp: null,
    user_full_name: [],
    user_email: [],
    status: []
  },

  visibleFiltersAdmin: { user_email: true, user_full_name: true },
  filterOptions: {
    status: ["Successful", "Failed", "Pending"]
  },

  payoutMethod: null,
  payoutMethodsFetching: false
})

/* ------------- Selectors ------------- */
export const selectAreFiltersDefault = (state) =>
  isEqual(state.requestsIntegrations.filters, INITIAL_STATE.filters)

/* ------------- Functions for reducer cases ------------- */
const getRequestsWithdrawalRequest = (state) => state.merge({ fetching: true })
const getRequestsWithdrawalSuccess = (state, { payload: result }) => {
  if (result.results) {
    return state.merge({ fetching: false, result })
  } else {
    return state.merge({
      fetching: false,
      result: {
        count: result?.length || 0,
        results: result
      }
    })
  }
}

const deleteWithdrawalRequest = (state, { payload: data }) => state.merge({ fetching: true })
const deleteWithdrawalSuccess = (state, { payload: data }) => {
  return state.merge({ fetching: false })
}

const requestsWithdrawalFailure = (state) => state.merge({ fetching: false })

export const requestsWithdrawalSetProp = (state, { key, value }) => {
  const obj = {}
  if (["filters", "visibleFilters", "visibleFiltersAdmin"]?.includes(key)) {
    if (key === "filters") obj.filtersLastUpd = new Date().getTime()
    obj[key] = { ...state?.[key], ...value }
  } else {
    obj[key] = value
  }
  return state.merge(obj)
}

export const getPayoutMethodRequest = (state) => state.merge({ payoutMethodsFetching: true })
export const getPayoutMethodSuccess = (state, { payload: payoutMethod }) => {
  return state.merge({ payoutMethodsFetching: false, payoutMethod })
}
export const getPayoutMethodFailure = (state) => state.merge({ payoutMethodsFetching: false })

export const setStatusRequest = (state) => state
export const setStatusSuccess = (state, { payload }) => {
  return state.merge({
    result: {
      ...state.result,
      results: state.result.results.map((item) => {
        if (item.id === payload.id) {
          return {
            ...item,
            status: payload.status
          }
        }
        return item
      })
    }
  })
}
export const setStatusFailure = (state) => state

export const clearRequestsWithdrawalFilters = (state) => {
  return state.merge({ filters: INITIAL_STATE.filters })
}

const logout = (state) => {
  return state.merge({
    ...INITIAL_STATE,
    filters: state.filters,
    columnsAdmin: state.columnsAdmin,
    visibleFiltersAdmin: state.visibleFiltersAdmin
  })
}

// Bump when the shape of the saved `{ version, filters, columnsAdmin, visibleFiltersAdmin }`
// payload changes.
export const REQUESTS_WITHDRAWAL_PREFERENCES_VERSION = 1

const applyPreferences = (state, { payload }) => {
  const preference = payload?.["requests-withdrawal"]?.data
  if (!preference || preference.version !== REQUESTS_WITHDRAWAL_PREFERENCES_VERSION) return state
  if (!preference.filters || !preference.columnsAdmin || !preference.visibleFiltersAdmin)
    return state

  return state.merge({
    filters: preference.filters,
    columnsAdmin: preference.columnsAdmin,
    visibleFiltersAdmin: preference.visibleFiltersAdmin
  })
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_REQUESTS_WITHDRAWAL_REQUEST]: getRequestsWithdrawalRequest,
  [Types.GET_REQUESTS_WITHDRAWAL_SUCCESS]: getRequestsWithdrawalSuccess,

  [Types.DELETE_WITHDRAWAL_REQUEST]: deleteWithdrawalRequest,
  [Types.DELETE_WITHDRAWAL_SUCCESS]: deleteWithdrawalSuccess,

  [Types.REQUESTS_WITHDRAWAL_FAILURE]: requestsWithdrawalFailure,

  [Types.GET_PAYOUT_METHOD_REQUEST]: getPayoutMethodRequest,
  [Types.GET_PAYOUT_METHOD_SUCCESS]: getPayoutMethodSuccess,
  [Types.GET_PAYOUT_METHOD_FAILURE]: getPayoutMethodFailure,

  [Types.SET_STATUS_REQUEST]: setStatusRequest,
  [Types.SET_STATUS_SUCCESS]: setStatusSuccess,
  [Types.SET_STATUS_FAILURE]: setStatusFailure,

  [Types.CLEAR_REQUESTS_WITHDRAWAL_FILTERS]: clearRequestsWithdrawalFilters,

  [Types.REQUESTS_WITHDRAWAL_SET_PROP]: requestsWithdrawalSetProp,

  [Types.LOGOUT]: logout,

  [preferencesSuccess.type]: applyPreferences
})
